

import { Component, Vue, Prop } from 'vue-property-decorator';
import PazMenuDatePicker from "@pazion/pazion-core/src/components/input/PazMenuDatepicker.vue";
import { IWorktype, ProductionStatusesEnum } from '@pazion/pazion-catalog/src/models/production.model';
import { getProductionWorktypes } from '@pazion/pazion-catalog/src/services/order-service';
import PazMenuDatePicker from "@pazion/pazion-core/src/components/input/PazMenuDatepicker.vue";


@Component({
  components: {
     PazMenuDatePicker
  }
 
})
export default class ProductionFilterPanel extends Vue {


  @Prop({default: []}) 
  lineStatuses! : {label: 'srtring', value: ProductionStatusesEnum}[]

  @Prop() fromDetails?: boolean

  public lineStatus: string | null = null;

  private productionWorkTypes = {} as IWorktype;

  public lineWorkType: IWorktype | null = null;

  public deliverAtDefaultDate: string | null = null;


    //FILTERS
  public dateEqualOperator = 'like';
  public operatorsArray = [
    {
      name: 'lt',
      id: '<'
    },
    {
      name: 'lte',
      id: '<='
    },
    {
      name: 'like',
      id: '='
    },
    {
      name: 'gt',
      id: '>'
    },
    {
      name: 'gte',
      id: '>='
    }
  ];


  public recordsLineStatuses = [
    { label: 'New', value: ProductionStatusesEnum.NEW },
    { label: 'Bewerken', value: ProductionStatusesEnum.BEWERKEN },
    { label: 'Processed', value: ProductionStatusesEnum.PROCESSED }
  ]


  createFiltersObject() {
    let filter: {
      status?: string | null,
      worktype?: string | null,
      "production.deliverAt"?: {} | null
    } = {
      status: null,
      worktype: null,
      "production.deliverAt": null
    };

    this.lineStatus !== null && this.lineStatus
      ? Object.assign(filter, { status: this.lineStatus })
      : delete filter.status;

    this.lineWorkType !== null && this.lineWorkTypes
      ? Object.assign(filter, { worktype: this.lineWorkType })
      : delete filter.worktype;


    if (this.deliverAtDefaultDate !== null && this.deliverAtDefaultDate) {
      const currentOperator = this.dateEqualOperator ? this.dateEqualOperator : 'like'
      const filterField = {
        "production.deliverAt": { [currentOperator]: this.deliverAtDefaultDate }
      };
      Object.assign(filter, filterField)
    } else {
      delete filter["production.deliverAt"];
    }
    
    localStorage.setItem('prodFilters', JSON.stringify(filter) )
    return filter;
  }


  onChangeItemsFilter(fromDefault?: boolean) {
    const prevFilters = localStorage.getItem('prodFilters');
    const getSavedFilters = prevFilters && fromDefault ? JSON.parse(prevFilters) : {};
    if(getSavedFilters && Object.keys(getSavedFilters).length > 0) {
      Object.entries(getSavedFilters).map( ([key, value]) => {
        if(key === 'status') {
          this.lineStatus = value
        }
        if(key ==='worktype') {
          this.lineWorkType = value
        }
        if(key === 'production.deliverAt') {
          this.deliverAtDefaultDate = Object.values(value)[0];
          this.dateEqualOperator = Object.keys(value)[0];          
        }

      });
    }
    const filters = this.createFiltersObject();
    const fullFilter = Object.assign(getSavedFilters, filters);
    this.onChangeGroupFilter(fullFilter);
  }

  // NOTE: FILTER – DeliveryAt
  setDeliverDateFilter(selectedDate: string) {
    this.deliverAtDefaultDate = selectedDate;
    const filters = this.createFiltersObject();
    this.onChangeGroupFilter(filters);
  }


  onChangeOperatorType() {
    if (this.deliverAtDefaultDate) {
      const filters = this.createFiltersObject();
      this.onChangeGroupFilter(filters);
    }
  }

  onChangeGroupFilter(filters: {[key:string]: any}) {
     this.$emit('onChangeFilters', filters)
  }

  async getInstances() {
    this.productionWorkTypes = await getProductionWorktypes();
  }

  setDefaultFilter() {
    if(!this.fromDetails)
      this.lineStatus = this.recordsLineStatuses[0].value;
    this.onChangeItemsFilter(true)
  }


  get lineWorkTypes() {
      const prodTypesArray = Object.values(this.productionWorkTypes);
      return prodTypesArray
  }

  mounted() {
    this.getInstances();
    this.setDefaultFilter();
  }

}
